import { Paper, styled } from "@mui/material";

const PREFIX = "PaperCandidateChallenge";

export const paperCandidateChallengeClasses = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`,
  headerResponsiveContainer: `${PREFIX}-headerResponsiveContainer`,
  headerTitle: `${PREFIX}-headerTitle`,
  headerActions: `${PREFIX}-headerActions`,
  objectivesList: `${PREFIX}-objectivesList`,
  objectivePaper: `${PREFIX}-objectivePaper`,
  objectiveActions: `${PREFIX}-objectiveActions`,
};

export const PaperCandidateChallengeRoot = styled(Paper)(({ theme }) => ({
  [`&.${paperCandidateChallengeClasses.root}`]: {
    borderRadius: 0,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    [`& .${paperCandidateChallengeClasses.header}`]: {
      flexDirection: "row",
      alignItems: "center",
      gap: theme.spacing(1),
      [`& .${paperCandidateChallengeClasses.headerResponsiveContainer}`]: {
        flex: "auto",
        flexDirection: "column",
        gap: theme.spacing(1),
        [`${theme.breakpoints.up("tablet")}`]: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        },
      },
      [`& .${paperCandidateChallengeClasses.headerTitle}`]: {
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1),
      },
      [`& .${paperCandidateChallengeClasses.headerActions}`]: {
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1),
      },
    },
    [`& .${paperCandidateChallengeClasses.objectivesList}`]: {
      gap: theme.spacing(1),
      [`& .${paperCandidateChallengeClasses.objectivePaper}`]: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        [`& .${paperCandidateChallengeClasses.objectiveActions}`]: {
          flexDirection: "row",
          gap: theme.spacing(1),
        },
      },
    },
  },
}));
